import React from 'react';
import {
  BadgeCheck,
  Building2,
  ClipboardCheck,
  FileCheck2,
  Leaf,
  LockKeyhole,
  ShieldCheck,
  Sparkles,
} from 'lucide-react';
import {
  GOVERNED_COMPLIANCE_HEADING,
  GOVERNED_COMPLIANCE_ITEMS,
} from '@/data/governedCompliance';

const ICONS = {
  shield: ShieldCheck,
  badge: BadgeCheck,
  lock: LockKeyhole,
  leaf: Leaf,
  clipboard: ClipboardCheck,
  sparkles: Sparkles,
  'file-check': FileCheck2,
  building: Building2,
};

const slugify = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const GovernedComplianceGrid = ({ variant = 'footer', showHeader = true }) => {
  const isFooter = variant === 'footer';

  return (
    <section className="space-y-3" data-testid={`governed-compliance-${variant}`}>
      {showHeader && (
        <p className={isFooter ? 'text-[11px] font-semibold uppercase tracking-[0.28em] text-orange-400' : 'text-xs font-semibold uppercase tracking-[0.28em] text-orange-600'}>
          {GOVERNED_COMPLIANCE_HEADING}
        </p>
      )}

      <ul className="flex flex-wrap gap-2" data-testid={`governed-compliance-list-${variant}`}>
        {GOVERNED_COMPLIANCE_ITEMS.map((item) => {
          const Icon = ICONS[item.iconKey] || ShieldCheck;
          const slug = slugify(item.name);

          return (
            <li
              key={item.name}
              title={item.description}
              className={isFooter
                ? 'inline-flex items-center gap-1.5 rounded-full border border-slate-700 bg-slate-900/80 px-3 py-1.5 text-xs text-slate-200'
                : 'inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 shadow-sm'}
              data-testid={`governed-compliance-item-${slug}`}
            >
              <Icon aria-hidden="true" className={isFooter ? 'h-3.5 w-3.5 text-orange-300' : 'h-3.5 w-3.5 text-orange-600'} />
              <span className="font-medium">{item.name}</span>
              <span className={isFooter ? 'text-[10px] uppercase tracking-[0.1em] text-emerald-300/90' : 'text-[10px] uppercase tracking-[0.1em] text-emerald-700'}>
                {item.status}
              </span>
            </li>
          );
        })}
      </ul>

      <p className={isFooter ? 'text-[11px] text-slate-400' : 'text-xs text-slate-500'} data-testid={`governed-compliance-disclaimer-${variant}`}>
        Displayed for information purposes only.
      </p>
    </section>
  );
};
